module.exports = __webpack_public_path__ + "assets/img/8.25a0de11.png";